import { StyleSheet } from 'react-native';

export const createStyles = () => {
  return StyleSheet.create({
    container: {
      flex: 1,
    },
    header: {
      padding: 16,
      borderBottomWidth: 1,
    },
    headerContent: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    titleContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12,
    },
    title: {
      fontSize: 24,
      fontWeight: '700',
    },
    createButton: {
      width: 40,
      height: 40,
      borderRadius: 20,
      alignItems: 'center',
      justifyContent: 'center',
    },
    list: {
      paddingVertical: 8,
      flexGrow: 1,
    },
    columnsContainer: {
      flexDirection: 'row',
      gap: 16,
      paddingHorizontal: 16,
      alignItems: 'flex-start',
    },
    column: {
      flex: 1,
    },
    postWrapper: {
      marginHorizontal: -16, // Remove PostCard's built-in horizontal margin in column layout
    },
  });
};
